import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createGcpLbIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M31.2 19.9999H28.4V25.5999H31.2V19.9999Z" fill="#669DF6"/>
    <path d="M21.4 19.9999H18.6V25.5999H21.4V19.9999Z" fill="#669DF6"/>
    <path d="M11.6 19.9999H8.80002V25.5999H11.6V19.9999Z" fill="#669DF6"/>
    <path d="M21.4 18.6001H18.6V13.0001L20 13L21.4 13.0001V18.6001Z" fill="#4285F4"/>
    <path d="M31.2 18.6H8.80002V21.4H31.2V18.6Z" fill="#669DF6"/>
    <path d="M10.2 25.6001H6V34L10.2 34.0001V25.6001Z" fill="#AECBFA"/>
    <path d="M14.4 25.6001H10.2V34.0001H14.4V25.6001Z" fill="#669DF6"/>
    <path d="M20 25.6001H15.8V34.0001H20V25.6001Z" fill="#AECBFA"/>
    <path d="M24.2 25.6001H20V34.0001L24.2 34V25.6001Z" fill="#669DF6"/>
    <path d="M29.8 25.6001H25.6V34.0001H29.8V25.6001Z" fill="#AECBFA"/>
    <path d="M34 25.6001H29.8V34.0001H34V25.6001Z" fill="#669DF6"/>
    <path d="M11.6 6V13L18.6 13.0001L20 13V6H11.6Z" fill="#AECBFA"/>
    <path d="M21.4 13.0001L28.4 13L28.4 6H20V13L21.4 13.0001Z" fill="#669DF6"/>
    <path d="M14.3995 25.6005H11.6005V21.3995H18.6005V25.6005H15.8003V34H24.1998V25.6005H21.3995V21.3995H28.3995V25.6005H25.6005V34H34V25.6005H31.1998V18.6005H21.3995V13H28.3995V6.00002H20V4.72729H29.6723V14.2727H22.6723V17.3278H32.4725V24.3278H35.2728V35.2728H4.72729V24.3278H7.52754V17.3278H17.3278V14.2727H10.3278V4.72729H20V6.00002H11.6005V13H18.6005V18.6005H8.80027V25.6005H6.00002V34H14.3995V25.6005ZM12.8732 24.3278H17.3278V22.6723H12.8732V24.3278ZM22.6723 24.3278H27.1268V22.6723H22.6723V24.3278Z" fill="white"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const gcpLbIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createGcpLbIcon,
);
